import { useEffect, useState } from "react";
import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";

const NOTHING = () => Promise.resolve({ data: null });

// Everything the Route Planning screen needs, from the API: the journeys whose
// route can still be planned, the chosen journey's route and route history, and
// (when the caller may edit) the states to pick from. Each part loads
// independently so one failure does not blank the rest.
export default function useTspRoutePlanningData({ initialJourneyId, canManage }) {
  const [journeyId, setJourneyId] = useState(initialJourneyId || "");

  const journeys = useTspApiResource(
    () => TspApiService.listJourneys({ status: "DRAFT,PLANNED,APPROVED,IN_PROGRESS", sort: "journey_name", order: "asc", limit: 100 }),
    []
  );

  // No journey chosen yet: take the first one in the list.
  useEffect(() => {
    if (!journeyId && journeys.data && journeys.data.length > 0) setJourneyId(String(journeys.data[0].id));
  }, [journeyId, journeys.data]);

  const route = useTspApiResource(() => (journeyId ? TspApiService.getRoute(journeyId) : NOTHING()), [journeyId]);
  const history = useTspApiResource(() => (journeyId ? TspApiService.getRouteHistory(journeyId, { limit: 50 }) : NOTHING()), [journeyId]);
  const states = useTspApiResource(() => (canManage ? TspApiService.listStates() : NOTHING()), [canManage]);

  const reloadRoute = () => {
    route.reload();
    history.reload();
  };

  return { journeyId, setJourneyId, journeys, route, history, states, reloadRoute };
}
